<template>
  <path :style="{ fill : $attrs.bgColor }"
        d="m13.2,7.6c2.1-1.3,4.6-1.9,7.1-1.8,2.8,0,5.7.7,7.9,2.5,2,1.6,3.3,4,4,6.4-.8.2-1.6.5-2.5.6-.6-2.1-1.8-4.2-3.6-5.4-1.7-1.2-3.8-1.5-5.9-1.7-2.1,0-4.3.4-6.1,1.7-1.9,1.3-3,3.6-3.6,5.8-.6,2.7-.6,5.6,0,8.3.4,1.9,1.3,3.8,2.8,5.2,1.6,1.5,3.9,2.2,6.1,2.3,2.1,0,4.3-.2,6.1-1.3,1-.7,2-1.6,2.5-2.7.5-1.1.6-2.5.2-3.6-.3-1-1.1-1.8-2-2.4-.3,1.6-.8,3.3-2,4.4-1.4,1.3-3.4,1.7-5.3,1.4-1.3-.2-2.7-.9-3.5-2-1.1-1.4-1.2-3.5-.2-5,.8-1.3,2.3-2.1,3.8-2.3,1.6-.3,3.2-.2,4.8,0-.2-1.1-.7-2.2-1.8-2.7-1.7-.7-3.9-.4-5,1.2-.7-.4-1.4-.9-2.1-1.4.9-1.3,2.2-2.2,3.7-2.5,2-.4,4.2,0,5.7,1.3,1.3,1.1,1.8,2.8,2,4.4,0,.2,0,.5.2.6,1.5.7,2.9,1.8,3.6,3.3.9,1.8,1,3.9.4,5.8-.8,2.4-2.9,4.3-5.2,5.3-2.8,1.1-6,1.2-8.9.5-2.4-.6-4.5-1.9-6-3.8-1.8-2.3-2.5-5.2-2.8-8-.1-2.6,0-5.2.7-7.7.7-2.6,2.4-5,4.7-6.5Zm4.3,14c-.5.7-.5,1.7.1,2.4.6.6,1.4.8,2.2.9,1,0,2-.1,2.8-.8.9-.9,1.2-2.3,1.3-3.5-1.3-.2-2.7-.3-4.1-.1-.9.1-1.8.4-2.3,1.2Z"/>
</template>

<script>
export default {
  name: "svgThreads"
}
</script>

<style scoped>

</style>